(function(){
  /* Colour overrides. The brand stylesheet forces dark text inside the drawer (id selector, !important),
     so these use a higher specificity and are appended last. Mobile and tablet only. */
  var P='html body #header-component .menu-drawer';
  var css='@media (max-width:989px){'+
    P+' a,'+P+' button,'+P+' span,'+P+' p,'+P+' li,'+P+' .pf-nav-top{color:#F5F4F0!important}'+
    P+' .pf-nav-top span{background:#9FD9BB!important}'+
    P+' .menu-drawer__close-button svg path{stroke:#F5F4F0!important}'+
    P+' .menu-drawer__menu-item--mainlist::before{color:#9FD9BB!important}'+
    P+' .menu-drawer__menu-item--mainlist::after{color:rgba(245,244,240,.35)!important}'+
    P+' a.menu-drawer__menu-item--mainlist[aria-current=page],'+P+' a.menu-drawer__menu-item--mainlist[aria-current=page] span{color:#9FD9BB!important}'+
    P+' .resource-card__content .compare-at-price,'+P+' .resource-card__content .compare-at-price span{color:rgba(245,244,240,.45)!important}'+
    P+' .resource-card__content .price-item__group.price,'+P+' .resource-card__content .price-item__group.price span{color:#9FD9BB!important}'+
    P+' a.pf-nav-cta,'+P+' a.pf-nav-cta span{color:#101312!important}'+
    P+' .pf-nav-links a{color:rgba(245,244,240,.65)!important}'+
    P+' p.pf-nav-note{color:rgba(245,244,240,.5)!important}'+
    '}';
  function addStyle(){
    if(document.getElementById('pf-nav-colors'))return;
    var s=document.createElement('style');s.id='pf-nav-colors';s.textContent=css;(document.body||document.head).appendChild(s);
  }
  function build(){
    addStyle();
    var d=document.querySelector('.menu-drawer');
    if(!d||d.querySelector('.pf-nav-top'))return;
    var t=document.createElement('div');t.className='pf-nav-top';t.innerHTML='Parform<span></span>';
    var nav=d.querySelector('.menu-drawer__navigation');
    if(nav)d.insertBefore(t,nav);else d.appendChild(t);
    var tpl=document.getElementById('pf-nav-extra');
    if(tpl)d.appendChild(tpl.content.cloneNode(true));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
  document.addEventListener('toggle',build,true);
  document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.header__icon--summary'))setTimeout(build,50);},true);
})();
